import script from "./MMyCustomers.vue?vue&type=script&setup=true&lang=js"
export * from "./MMyCustomers.vue?vue&type=script&setup=true&lang=js"

import "./MMyCustomers.vue?vue&type=style&index=0&id=bb8c0b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8c0b82"]])

export default __exports__